import { isBoolean, isEmpty, isNumber, isObjectLike, isString, trim } from 'lodash'

const removeEmptyItems = (item: object | any[]): any => {
  if (Array.isArray(item)) {
    return item
      .map(value => (value && typeof value === 'object' ? removeEmptyItems(value) : value))
      .filter(value => {
        if (isObjectLike(value)) {
          return !isEmpty(value)
        } else {
          if (isString(value)) {
            return trim(value).length > 0
          } else if (isNumber(value)) {
            return true
          } else if (isBoolean(value)) {
            return true
          }
          return false
        }
      })
  } else if (typeof item === 'object') {
    return Object.fromEntries(
      Object.entries(item)
        .filter(([, value]) => {
          if (isObjectLike(value)) {
            return !isEmpty(value)
          } else {
            if (isString(value)) {
              return trim(value).length > 0
            } else if (isNumber(value)) {
              return true
            } else if (isBoolean(value)) {
              return true
            }
            return false
          }
        })
        .map(([key, value]) => [key, value === Object(value) ? removeEmptyItems(value) : value])
    )
  }
}

export default removeEmptyItems
